import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment, useEffect, useState } from "react";
import DocImg from "../images/doc.svg";
import RemoveImg from "../images/docClose.svg";
import { baseURL } from "../constants/Api";
import axios from "axios";
import ButtonLoader from "./loaders/ButtonLoader2";
import imageCompression from "browser-image-compression";
import heic2any from 'heic2any';
import { DocumentSubmitButtonClick } from "../utils/Analytics";
// import ButtonLoader from "../../components/loaders/ButtonLoader";
function DocModal(props) {
  const [doc1Array, setDoc1Array] = useState([]);
  const [doc2Array, setDoc2Array] = useState([]);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const appUserId = localStorage.getItem("appUserId");
  const [loading, setLoading] = useState(false);
  const [compressLoading, setCompressLoading] = useState(false);
  const reservationId = localStorage.getItem("reservationId");
  const [docError, setDocError] = useState(false);
  const [showAlreadyDOc, setShowAlreadyDOc] = useState(false);
  const [uploadedDocsNumber, setUploadedDocsNumber] = useState();
  const [previousDocs, setPreviousDocs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  function closeModal() {
    props.hide();
  }

  function getImageSrcFromFile(item) {
    return URL.createObjectURL(item);
  }

  // async function handleDoc1(e) {
  //   // console.log(e.target.files);
  //   const imageFiles = e.target.files;
  //   // console.log(`originalFile size ${imageFile.size / 1024 / 1024} MB`);

  //   const options = {
  //     maxSizeMB: 1,
  //     maxWidthOrHeight: 1920,
  //     useWebWorker: true,
  //   };
  //   try {
  //     const compressedFile = await imageCompression(imageFiles, options);
  //     console.log("ji");
  //     console.log(compressedFile);
  //     var newArray1 = [...doc1Array, compressedFile];
  //     setDoc1Array(newArray1);
  //     setError("");
  //   } catch (error) {
  //     console.log(error);
  //     setDocError(true);
  //   }
  // }

  function fileToBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  }

  const generateCurrentTime = () => {
    const currentTime = new Date().getTime().toString().slice(-16);
    return currentTime;
  };

  class CustomBlob extends Blob {
    constructor(blobParts, options = {}) {
      super(blobParts, options);
      this.lastModified = generateCurrentTime(); // Default lastModified timestamp
    }
  }

  function base64ToBlob(base64, lastModified) {
    console.log(lastModified);
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new CustomBlob([byteArray], {
      type: "images/png",
      lastModified: lastModified,
    });
  }

  const addTOBase64 = async (imageFiles) => {
    const base64Strings = [];

    for (let i = 0; i < imageFiles.length; i++) {
      const file = imageFiles[i];
      const base64String = await fileToBase64(file);
      base64Strings.push(base64String);

      // You can store this base64String in your database or anywhere else

      // To retrieve the image later:
      const blob = base64ToBlob(base64String, file.lastModified);
      const imageUrl = URL.createObjectURL(blob);
    }

    localStorage.setItem("base64FileStrings", JSON.stringify(base64Strings));
  };

  //original
  // async function handleDoc1(e) {
  //   const imageFiles = e.target.files;
  //   setCompressLoading(true);
  //   // console.log(imageFiles);
  //   // localStorage.setItem(
  //   //   "storedFiles",
  //   //   JSON.stringify(imageFiles)
  //   // );

  //   const options = {
  //     maxSizeMB: 1,
  //     maxWidthOrHeight: 1920,
  //     useWebWorker: true,
  //   };

  //   try {
  //     const compressedFiles = await Promise.all(
  //       Array.from(imageFiles).map(async (file) => {
  //         return await imageCompression(file, options);
  //       })
  //     );

  //     var newArray1 = [...doc1Array, ...compressedFiles];
  //     setDoc1Array(newArray1);
  //     localStorage.setItem("storedFiles", JSON.stringify(newArray1));
  //     setError("");
  //     setCompressLoading(false);
  //   } catch (error) {
  //     console.log(error);
  //     setDocError(true);
  //     setCompressLoading(false);
  //   }
  // }
  
  //heic format accepted
  async function handleDoc1(e) {
    const imageFiles = e.target.files;
    setCompressLoading(true);
  
    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 1920,
      useWebWorker: true,
    };
  
    try {
      const processedFiles = await Promise.all(
        Array.from(imageFiles).map(async (file) => {
          // Check if file is HEIC and convert it to JPEG
          if (file.type === 'image/heic' || file.name.endsWith('.heic')) {
            try {
              const convertedBlob = await heic2any({
                blob: file,
                toType: 'image/jpeg',
              });
              // Convert the Blob to File
              return new File([convertedBlob], file.name.replace(/\.heic$/, '.jpeg'), { type: 'image/jpeg' });
            } catch (conversionError) {
              console.error('Error converting HEIC file:', conversionError);
              return null; // Skip this file if conversion fails
            }
          }
          return file; // Return non-HEIC files as-is
        })
      );
  
      // Filter out any null entries (failed conversions)
      const validFiles = processedFiles.filter((file) => file !== null);
  
      // Compress all valid files
      const compressedFiles = await Promise.all(
        validFiles.map((file) => imageCompression(file, options))
      );
  
      // Add compressed files to the state and local storage
      const newArray1 = [...doc1Array, ...compressedFiles];
      setDoc1Array(newArray1);
      localStorage.setItem('storedFiles', JSON.stringify(newArray1));
      setError('');
      setCompressLoading(false);
    } catch (error) {
      console.log(error);
      setDocError(true);
      setCompressLoading(false);
    }
  }
  

  const removeDoc1 = (param) => {
    var filterArray1 = doc1Array.filter((item) => item.lastModified !== param);
    setDoc1Array(filterArray1);
  };

  const removeFromLocal = (param) => {
    var filterArray1 = previousDocs.filter(
      (item) => item.lastModified !== param
    );
    setPreviousDocs(filterArray1);
    addTOBase64(filterArray1);
  };

  const sumbitDocs = () => {
    if (doc1Array.length == 0) {
      setError("validation");
    } else if (docError) {
      setError("axios");
      setDoc2Array([]);
      setDoc1Array([]);
    } else {
      docSubmit();
      DocumentSubmitButtonClick();
    }
  };

  const docSubmit = async () => {
    const formData = new FormData();
    for (let i = 0; i < doc1Array.length; i++) {
      formData.append("idProof1[]", doc1Array[i]);
    }
    for (let i = 0; i < doc2Array.length; i++) {
      formData.append("idProof2[]", doc2Array[i]);
    }
    formData.append("appUserId", appUserId);
    formData.append("reservationId", reservationId);

    setLoading(true);
    try {
      await axios
        .post(`${baseURL}/api/guestDocsV21`, formData)
        .then(function (response) {
          if (response.data.success == true) {
            setSuccess(true);
            setLoading(false);
            setTimeout(() => {
              closeModal();
            }, 1200);
            addTOBase64(doc1Array);
            setUploadedDocsNumber(doc1Array.length);
          } else {
            setError("axios");
            setLoading(false);
          }
        });
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const selectPrevDocs = () => {
    setDoc1Array((prevImages) => [...prevImages, ...previousDocs]);
    setPreviousDocs([]);
  };

  useEffect(() => {
    const storedImages = localStorage.getItem("base64FileStrings");
    if (storedImages) {
      try {
        const base64Strings = JSON.parse(storedImages);
        const blobs = base64Strings.map(base64ToBlob);
        // setImageFiles(prevImages => [...prevImages, ...blobs]);
        // setDoc1Array(blobs);
        setPreviousDocs(blobs);
        if (base64Strings.length > 0) {
          setShowAlreadyDOc(true);
          setUploadedDocsNumber(base64Strings.length);
        }
      } catch (error) {
        console.error("Error parsing JSON:", error);
        // Handle the error, e.g., by showing an error message to the user
      }
    }
  }, []);

  return (
    <>
      <Transition appear show={true} as={Fragment}>
        <Dialog as="div" className="relative z-[999999]" onClose={closeModal}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-md bg-[#171538] p-4 pt-2 text-left align-middle shadow-xl transition-all">
                  <Dialog.Title
                    as="h3"
                    className="text-lg font-medium leading-6 text-gray-900"
                  ></Dialog.Title>
                  <div className="doc-modal flex-col items-center justify-center mt-2">
                    <div className="flex justify-center items-center"></div>
                    <div className="head">Upload Documents</div>
                    <div className="label my-2 mb-4">
                      Upload ID Verification documents for quick check-in
                    </div>
                    {props?.isUploaded && <div className="text-green-500 text-xs font-normal mt-4">Documents Already uploaded in this booking</div>}
                    {previousDocs.length != 0 && (
                      <div className=" doc-container mt-2">
                        <div className="doc-preview flex flex-wrap items-center gap-4  mb-2">
                          {previousDocs.map((item, i) => (
                            <div
                              key={i}
                              id={item.lastModified}
                              className="img-div relative"
                              style={{
                                backgroundImage: `url(${getImageSrcFromFile(
                                  item
                                )})`,
                              }}
                            >
                              <span
                                className="absolute -right-2 -top-2"
                                title="remove"
                                onClick={() =>
                                  removeFromLocal(item.lastModified)
                                }
                              >
                                <img
                                  className="w-5 h-5"
                                  src={RemoveImg}
                                  alt=""
                                />
                              </span>
                            </div>
                          ))}
                        </div>
                        <div className="flex justify-between items-center mt-3">
                          <div className="prev-label">
                            {previousDocs.length === 1 ? (
                              <span> Previously uploaded file</span>
                            ) : (
                              <span> Previously uploaded files</span>
                            )}
                          </div>
                          <div className="select-file" onClick={selectPrevDocs}>
                            {previousDocs.length === 1 ? (
                              <span>Select this file</span>
                            ) : (
                              <span>Select these files</span>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="doc-container mt-5">
                      <div className="head mb-2 ml-2">{props?.doc[0] ? <span>{props?.doc[0]} :</span>  : "Document"}</div>
                      <div
                        className={
                          doc1Array.length !== 0
                            ? "flex flex-wrap items-center justify-center gap-3"
                            : "flex justify-center"
                        }
                      >
                        {doc1Array.length !== 0 && (
                          <div className="doc-preview items-center flex flex-wrap gap-4  mb-2">
                            {doc1Array.map((item, i) => (
                              <div
                                key={i}
                                id={item.lastModified}
                                className="img-div relative"
                                style={{
                                  backgroundImage: `url(${getImageSrcFromFile(
                                    item
                                  )})`,
                                }}
                              >
                                <span
                                  className="absolute -right-2 -top-2"
                                  title="remove"
                                  onClick={() => removeDoc1(item.lastModified)}
                                >
                                  <img
                                    className="w-5 h-5"
                                    src={RemoveImg}
                                    alt=""
                                  />
                                </span>
                              </div>
                            ))}
                          </div>
                        )}
                        <input
                          disabled={compressLoading}
                          className="mt-3 p-2"
                          type="file"
                          accept=".heic, image/*"
                          hidden
                          id="doc1"
                          multiple
                          onChange={handleDoc1}
                        />
                        <div className="relative w-fit">
                          <label
                            htmlFor="doc1"
                            className="h-fit"
                          >
                            {isLoading && <div class="spinner-docs"></div>}
                            <img
                              className="cursor-pointer w-[80px] m-auto"
                              src={DocImg}
                              alt="Document"
                              onLoad={() => setIsLoading(false)} 
                              style={{ display: isLoading ? 'none' : 'block' }} 
                            />
                            {compressLoading && (
                              <div
                                className="absolute left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2"
                              >
                                <ButtonLoader />
                              </div>
                            )}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex w-full justify-center mt-3 relative">
                    <div
                      disabled={loading || compressLoading}
                      onClick={sumbitDocs}
                      className="Docupload-btn w-full"
                    >
                      <span className="mr-[8px]" > Upload Documents</span>
                      {loading && <ButtonLoader  className="ButtonLoader"/>}
                    </div>
                  </div>
                  {error == "validation" && (
                    <div className="w-full flex justify-center">
                      <div className="error-doc text-center mt-3">
                        Please select documents..
                      </div>
                    </div>
                  )}
                  {error == "axios" && (
                    <div className="w-full flex justify-center">
                      <div className="error-doc text-center mt-3">
                        something went wrong
                      </div>
                    </div>
                  )}
                  {success && (
                    <div className="w-full flex justify-center">
                      <div className="success-doc text-center mt-3">
                        Successfully Uploaded!
                      </div>
                    </div>
                  )}
                  <div className="absolute top-2 right-2 ">
                    <button
                      type="button"
                      className="outline-none rounded-full hover:bg-gray-500"
                      onClick={closeModal}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1"
                        stroke="white"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}

export default DocModal;
